import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.ShipPainting;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "ShipPainting.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "ShipPainting.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "ShipPainting.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/ShipPainting/scenes/IntroductionScene.ts